import Panolens360Viewer from "../components/Panolens360Viewer";
import Vr360 from "../components/VRComponent";
import Dashboard from "../pages/privatePages/Dashboard";
import Profile from "../pages/privatePages/Profile";
import AboutUs from "../pages/publicPages/AboutUs";
import Blog from "../pages/publicPages/Blog";
import BlogDetail from "../pages/publicPages/BlogDetail";
import ContactUsPage from "../pages/publicPages/ContactUsPage";
// import ContactUs from "../pages/publicPages/ContactUs";
import Home from "../pages/publicPages/Home";
import Login from "../pages/publicPages/Login";
import OurServices from "../pages/publicPages/OurServices";
import ProjectDetails from "../pages/publicPages/ProjectDetails";
import Projects from "../pages/publicPages/Projects";

export const publicPages = [
    {   
        name:'Login',
        icon:'',
        path:'/login',
        component:<Login/>
    },
    {
        name:'Home',
        icon:'',
        path:'/home',
        component:<Home/>
    },
    {
        name:'Home',
        icon:'',
        path:'/',
        component:<Home/>
    },
    {   
        name:'About Us',
        icon:'',
        path:'/about-us',
        component:<AboutUs/>
    },
    {   
        name:'Blog',
        icon:'',
        path:'/blog',
        component:<Blog/>
    },
    {   
        name:'Blog Details',
        icon:'',
        path:'/blog-details',
        component:<BlogDetail/>
    },
    {   
        name:'Projects',
        icon:'',
        path:'/projects',
        component:<Projects/>
    },
    {   
        name:'ProjectDetails',
        icon:'',
        path:'/project-details',
        component:<ProjectDetails/>
    },
    {   
        name:'VR Component',
        icon:'',
        path:'/vr-360',
        component:<Vr360/>
    },
    {   
        name:'360-image',
        icon:'',
        path:'/vr-image',
        component:<Panolens360Viewer/>
    },
    {   
        name:'Services',
        icon:'',
        path:'/services',
        component:<OurServices/>
    },
    {   
        name:'Contact Us',
        icon:'',
        path:'/contactUs',
        component:<ContactUsPage/>
    },
] 


export const privatePages = [
    {
        name:'Dashboard',
        icon:'',
        path:'/dashboard',
        component:<Dashboard/>
    },
    {
        name:'Profile',
        icon:'',
        path:'/profile',
        component:<Profile/>
    }
] 